module.exports = __webpack_public_path__ + "static/k-bread-menu-1-ea886d42e228925ecdc7992aa50d6fe4.png";